<template>
    <div id="my_receipts">
        <div class="ui icon dropdown button" v-dropdown>
            <div v-if="is_processing" class="signal"></div>
            <i class="newspaper large icon"></i>
            <!-- 我的簽收單 -->
            <!-- {{ $t('ui.toolbox.my_receipts.neme') }} -->
            <!-- <i class="dropdown icon"></i> -->
            <div class="menu">
                <div class="custom_item">
                    <DatePicker
                        v-model="dates"
                        :is_row="true"
                        :width="180"
                        key="my_receipts"
                    >
                    </DatePicker>
                    <!-- <el-date-picker
                        class="next_input_row"
                        style="width: 180px !important;"
                        v-model="dates"
                        unlink-panels
                        type="datetimerange"
                        align="center"
                        :start-placeholder="$t('ui.el.datepicker.startDate')"
                        :end-placeholder="$t('ui.el.datepicker.endDate')"
                        :picker-options="$store.state.element_ui_datepicker_daterange_options"
                        >
                    </el-date-picker> -->
                </div>
                <div
                    v-if="node.code == 'BY' || env == 'development'"
                    class="item" @click.prevent="print_my_receipts('A4', '1x3')">
                    {{ $t('ui.toolbox.my_receipts.print', {page: 'A4(1x3)'}) }}
                </div>
                <div
                    v-if="node.code == 'YYL' || env == 'development'"
                    class="item" @click.prevent="print_my_receipts('100x100', '1x1', 'label')">
                    {{ $t('ui.toolbox.my_receipts.print', {page: '100x100'}) }}
                </div>
                <div class="item" @click.prevent="print_my_receipts('A4')">
                    {{ $t('ui.toolbox.my_receipts.print', {page: 'A4'}) }}
                </div>
                <div class="item" @click.prevent="print_my_receipts('A5')">
                    {{ $t('ui.toolbox.my_receipts.print', {page: 'A5'}) }}
                </div>
                <div
                    v-if="node.identity == '6896bd65c1-28036-39768292'"
                    class="item" @click.prevent="force_location_print_my_receipts('A4', '1x3')">
                    {{
                        $t('ui.toolbox.my_receipts.print', {
                            page: 'A4(1x3)',
                            note: '('+$t('ui.toolbox.my_receipts.force_current_station')+')'
                        })
                    }}
                </div>
                <div class="item" @click.prevent="force_location_print_my_receipts('A4')">
                    <!-- A4列印(強制當前站點) -->
                    {{
                        $t('ui.toolbox.my_receipts.print', {
                            page: 'A4',
                            note: '('+$t('ui.toolbox.my_receipts.force_current_station')+')'
                        })
                    }}
                </div>
                <div class="item" @click.prevent="force_location_print_my_receipts('A5')">
                    {{
                        $t('ui.toolbox.my_receipts.print', {
                            page: 'A5',
                            note: '('+$t('ui.toolbox.my_receipts.force_current_station')+')'
                        })
                    }}
                </div>
                <div class="item">
                    <div class="ui slider checkbox">
                        <input type="checkbox"
                            v-model="is_beta"
                        >
                        <label>Beta</label>
                    </div>
                </div>
            </div>
        </div>

        <Receipts
            v-model="is_processing"
            :show_buttons="false"
            :conditions_search_params="{
                current_ship: true,
                current_operator_identity: current_staff.identity,
                updated_at: {
                    from: date_from,
                    to: date_to
                }
            }"
            :default_search_params="{
                condition: {
                    name: 'current_ship',
                    polarity: true,
                    current_operator_identity: current_staff.identity,
                    updated_at: {
                        from: date_from,
                        to: date_to
                    }
                },
                material: {
                    class_names: 'Waybill'
                },
                pagination: false
            }"
            :is_beta="is_beta"
            :operator_identity="current_staff.identity"
            :logo_url="'/images/' + node.company_en_name.replace(/(?:^|\.|\s?)([A-Z])/g,(x,y) => { return '_' + y.toLowerCase()}).replace(/^_/, '') + '_logo.jpg'"
            :title="node.company_short_name + ' ' + $t('ui.toolbox.my_receipts.customer_receipt')"
            :sub_title="node.website_url"
            :customer_service_hotline="node.customer_service_hotline"
            :logistician="current_staff"
            :channel_name="channel_name"
        >
        </Receipts>
        <Receipts
            v-model="is_processing"
            :show_buttons="false"
            :default_search_params="{
                condition: {
                    name: 'current_ship',
                    polarity: true,
                    current_operator_identity: current_staff.identity,
                    updated_at: {
                        from: date_from,
                        to: date_to
                    }
                },
                material: {
                    class_names: 'Waybill'
                },
                pagination: false
            }"
            :is_beta="is_beta"
            :operator_identity="current_staff.identity"
            :logo_url="'/images/' + node.company_en_name.replace(/(?:^|\.|\s?)([A-Z])/g,(x,y) => { return '_' + y.toLowerCase()}).replace(/^_/, '') + '_logo.jpg'"
            :title="node.company_short_name + ' ' + $t('ui.toolbox.my_receipts.customer_receipt')"
            :sub_title="node.website_url"
            :force_location="(current_staff.station) ? current_staff.station.name : ''"
            :customer_service_hotline="node.customer_service_hotline"
            :logistician="current_staff"
            :channel_name="force_location_channel_name"
        >
        </Receipts>
    </div>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"
import Receipts from "@toolbox/receipts/main.vue"
import moment from "moment";

export default {
    data () {
        return {
            dates: "",
            is_beta: true,
            is_processing: false,
            channel_name: "my_receipts",
            force_location_channel_name: "force_location_my_receipts"
        }
    },
    computed: {
        style: (instance) => instance.$store.state.style,
        node: (instance) => instance.$store.state.provider.node,
        current_staff: (instance) => instance.$store.state.provider.current_staff,
        date_from() {
            if (this.dates[0]) {
                return moment(this.dates[0]).format('YYYY-MM-DDTHH:mm:ss+08:00')
            } else {
                return moment(new Date()).startOf('day').format('YYYY-MM-DDTHH:mm:ss+08:00')
            }
        },
        date_to() {
            if (this.dates[1]) {
                return moment(this.dates[1]).format('YYYY-MM-DDTHH:mm:ss+08:00')
            } else {
                return moment(new Date()).endOf('day').format('YYYY-MM-DDTHH:mm:ss+08:00')
            }
        },
        env() {
            return ENV.NODE_ENV
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        async print_my_receipts(paper_size="A5", template=null, type=null) {
            this.$bus.$emit(this.channel_name, paper_size, template, type)
        },
        async force_location_print_my_receipts(paper_size="A5", template=null, type=null) {
            this.$bus.$emit(this.force_location_channel_name, paper_size, template, type)
        },
    },
    components: {
        Receipts,
        DatePicker,
    }
}
</script>

<style scoped lang="scss">
    #my_receipts .item {
        width: auto !important;
        height: auto !important;
    }
    .ui.slider.checkbox input:checked~.box:before,
    .ui.slider.checkbox input:checked~label:before {
        background-color: #21ba45 !important;
    }

    .signal {
        border: 5px solid white;
        border-radius: 30px;
        height: 30px;
        left: 50%;
        margin: -15px 0 0 -15px;
        opacity: 0;
        position: absolute;
        top: 50%;
        width: 30px;
        animation: pulsate 1s ease-out;
        animation-iteration-count: infinite;
    }
    @keyframes pulsate {
        0% {
            transform: scale(.1);
            opacity: 0.0;
        }
        50% {
            opacity: 1;
        }
        100% {
            transform: scale(1.4);
            opacity: 0;
        }
    }
</style>
